export default __webpack_public_path__ + "static/media/home-time-management.03b82b77.svg";